import {useParams} from 'react-router-dom';
import {UserPlaylists} from '../../../../../../../components/user-playlists/user-playlists';
import {useOffice} from '../../../../../../../contexts/office/context';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {ScreenPaths} from '../../../../../../../enums/screen-path';

export default function SeniorPlaylistsSystemAdministratorOfficeScreen() {
  const officeContext = useOffice();
  let {id}: {id?: string} = useParams();

  return (
    <UserPlaylists
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      playlistRowBaseLinkUrl={`${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}${ScreenPaths.SystemAdministrator_Playlists}`}
    />
  );
}
